import { useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Spin } from "antd";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
	FormHeaderComponent,
} from "../../components/styled/common";
import BackComponent from "../../components/BackComponent";
import MainButtonComponent from "../../components/MainButtonComponent";
import VolunteersExperienceForm, {
	applyExperienceLocalizableChanges,
	VolunteersExperienceGeneralValues,
	VolunteersExperienceLocalizableChanges,
} from "../../components/VolunteersExperienceForm";
import { useVolunteersExperienceContext } from "../../context/VolunteersExperienceContext/VolunteersExperienceContext";
import { VOLUNTEERS_EXPERIENCE_LIST_PATH } from "../../context/VolunteersExperienceContext/constants";
import { Culture } from "../../context/VolunteersHighlightContext/constants";

const EditVolunteersExperience = () => {
	const { id } = useParams<{ id: string }>();
	const {
		updateVolunteersExperience,
		getVolunteersExperienceDetails,
		clearVolunteersExperienceFormData,
		volunteersExperienceEditForm,
		setVolunteersExperienceEditForm,
		operationStatus,
	} = useVolunteersExperienceContext();

	const isFetching = operationStatus.type === "loading" && operationStatus.operation === "fetch";

	useEffect(() => {
		if (id) {
			getVolunteersExperienceDetails(id);
		}

		return () => {
			clearVolunteersExperienceFormData();
		};
	}, [id, getVolunteersExperienceDetails, clearVolunteersExperienceFormData]);

	const handleGeneralChange = useCallback((changes: Partial<VolunteersExperienceGeneralValues>) => {
		setVolunteersExperienceEditForm(prev => (prev ? { ...prev, ...changes } : null));
	}, [setVolunteersExperienceEditForm]);

	const handleLocalizableChange = useCallback((culture: Culture, changes: VolunteersExperienceLocalizableChanges) => {
		setVolunteersExperienceEditForm(prev => (prev ? {
			...prev,
			volunteersExperienceLocalizable: applyExperienceLocalizableChanges(prev.volunteersExperienceLocalizable, culture, changes),
		} : null));
	}, [setVolunteersExperienceEditForm]);

	return (
		<>
			<BackComponent text="Deneyim Listesine Dön" to={VOLUNTEERS_EXPERIENCE_LIST_PATH} />
			<ActionContainer>
				<Spin spinning={isFetching}>
					<ActionItemsContainer>
						<FormHeaderComponent>Gönüllü Deneyimi Güncelleme</FormHeaderComponent>
						{volunteersExperienceEditForm && (
							<VolunteersExperienceForm
								key={volunteersExperienceEditForm.experienceId}
								general={volunteersExperienceEditForm}
								localizables={volunteersExperienceEditForm.volunteersExperienceLocalizable}
								isRequired={false}
								onGeneralChange={handleGeneralChange}
								onLocalizableChange={handleLocalizableChange}
							/>
						)}
						<SubmitButtonOverlay>
							<MainButtonComponent
								onClick={updateVolunteersExperience}
								type="default"
								disabled={!volunteersExperienceEditForm}
								loading={operationStatus.type === "loading" && operationStatus.operation === "update"}
							>
								Güncelle
							</MainButtonComponent>
						</SubmitButtonOverlay>
					</ActionItemsContainer>
				</Spin>
			</ActionContainer>
		</>
	);
};

export default EditVolunteersExperience;
